module.exports = __webpack_public_path__ + "static/mw8-90daca8b47f73f69c7ce081d1ef08587.jpg";